<template>
  <div class="h-screen flex w-full bg-img">
    <div
      class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/4 lg:w-3/4 xl:w-1/2 mx-auto text-center"
    >
      <div class="grid grid-rows-2 md:grid-rows-1 grid-flow-col gap-0 lockscreen mt-5 mb-5">
        <div class="lock-image auto-cols-min"></div>
        <div class="login-form text-left auto-cols-max">
          <img
            v-if="image"
            key="onlineImg"
            :src="image"
            alt="user-img"
            width="100"
            height="100"
            class="rounded-full shadow-md cursor-pointer block mb-3"
          />
          <div class="form-group mb-3">
            <vs-input
              label=""
              type="password"
              class="w-full"
              placeholder="Enter your password"
            />
          </div>
          <div class="form-group mb-0">
            <vs-button> Log In </vs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      image: require("@/assets/images/author9.jpg"),
    };
  },
};
</script>
